import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
const volumeNames = ['Stretching Foundations & Essentials', 'Lower Body Flexibility & Mobility', 'Upper Body Flexibility & Mobility', 'Dynamic Stretching & Active Mobility', 'Flexibility for Health & Performance', 'Progressive Flexibility & Multi-Level Programming'];
const separateAreas = ['Beginner stretching classes.', 'Lower-body routines.', 'Upper-body flexibility.', 'Dynamic stretching.', 'Active mobility.', 'Full-body classes.', 'Recovery sessions.', 'Modifications.', 'Progressions.', 'Corrections.', 'Coaching cues.', 'Class structures.'];
export function SystemOverview() {
  return <section className="bg-background px-4 py-20 sm:py-28" data-id="element-320" data-mp="yw1r64bnl1wq">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1.1fr_1fr] lg:gap-16" data-id="element-321" data-mp="2fb2x35cnqnuu">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-322" data-mp="2ac8h0b62rdef">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-323" data-mp="284xr4v0a1jh0">
            Your complete 6-in-1 system
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-foreground sm:text-4xl" data-id="element-324" data-mp="2d53brr84q5pl">
            Why Search for Different Stretching Resources When Everything Can
            Be Organized Inside{' '}
            <span className="italic text-primary" data-id="element-325" data-mp="1kds15n0mhasz">One Complete System?</span>
          </h2>
          <Ornament align="left" className="mt-5" data-id="element-326" data-mp="1pf91nhf72v91" />
          <ol className="mt-8 divide-y divide-accent/25 border-y border-accent/25" data-id="element-327" data-mp="1udivnop6npt2">
            {volumeNames.map((name, index) => <li key={name} className="flex items-baseline gap-4 py-3.5" data-id="element-328" data-mp="1z6c1yh0av679" data-mpi={index}>
                <span className="w-6 shrink-0 font-display text-2xl font-semibold text-primary" data-id="element-329" data-mp="11q6i24102sbw">
                  {index + 1}
                </span>
                <span className="text-base font-medium text-foreground" data-id="element-330" data-mp="16m53pjuy1w8m">
                  {name}
                </span>
              </li>)}
          </ol>
          <p className="mt-5 text-sm font-semibold uppercase tracking-[0.08em] text-primary" data-id="element-331" data-mp="tnxis76rhvft">
            6 Volumes. 150 Classes. One Complete Stretching Teaching System.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="self-start rounded-2xl border border-accent/30 bg-surface p-6 shadow-card sm:p-9" data-id="element-332" data-mp="13f0lfdfcaih7">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-333" data-mp="ko0qzwp2sggj">
            Instead of searching separately for:
          </p>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-334" data-mp="210xwipre3lj4">
            {separateAreas.map(item => <li key={item} className="rounded-full border border-primary/20 bg-surface-subtle px-3 py-1.5 text-xs font-medium text-foreground" data-id="element-335" data-mp="1w2ec4tsg2hsv">
                {item}
              </li>)}
          </ul>
          <p className="mt-8 border-t border-accent/25 pt-6 font-display text-xl font-medium leading-8 text-foreground" data-id="element-336" data-mp="1umindhtawp6a">
            You get everything organized inside{' '}
            <span className="italic text-primary" data-id="element-337" data-mp="1ypf93he511eg">one professional 6-in-1 instructor system.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}